import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DocumentAuditService } from './services/document-audit.service';
import { DocumentTransitionDetails } from './models/document-transition-details';
import { DocumentLifeCycle } from './models/document-life-cycle';
import { DocumentAuditTrialDetails } from './models/document-audit-trial-details';
import { AuditTrialDetails } from '../shared/models/audits/audit-trial-details';
import { SharedConstants } from '../shared/constants/shared-constants';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrls: ['./audit-trail.component.scss'],
  encapsulation: ViewEncapsulation.None

})
export class AuditTrailComponent implements OnInit {

  @Input() documentNumber: string = '';
  @Input() documentVersion: string = '';
  auditAttributeDetailsOfTransaction!: AuditTrialDetails;
  documentTransitionDetails!: DocumentTransitionDetails;
  documentLifeCycleDetails: DocumentLifeCycle[] = [];
  documentAuditSummaryDetails: DocumentAuditTrialDetails[] = [];
  isDocumentAuditDetailsDataLoaded = false;
  constructor(private documentAuditService: DocumentAuditService, private messageService: MessageService) {
  }

  ngOnInit(): void {
    this.documentAuditService.getDocumentTransitionDetails(this.documentNumber, this.documentVersion)
      .subscribe({
        next: (documentTransitionDetails) => {
          this.documentTransitionDetails = documentTransitionDetails;
          this.documentLifeCycleDetails = documentTransitionDetails.documentLifeCycleDetails;
          this.documentAuditSummaryDetails = documentTransitionDetails.documentAuditTrialDetails;
          this.auditAttributeDetailsOfTransaction = documentTransitionDetails.documentAuditTrialDetails[0];
          this.isDocumentAuditDetailsDataLoaded = true;
          this.notifyMissingAttributesIfAny();
        },
        error: (error) => {
          this.messageService.add({
            severity: SharedConstants.Severity_Error,
            summary: SharedConstants.Audit_Fail_Error_Message,
            sticky: true
          });
        }
      });
  }
  showAuditItemDetails = (auditAttributeDetails: any) => {
    this.auditAttributeDetailsOfTransaction = auditAttributeDetails;
  }
  
  private hasMissingAttributes(): boolean {
    const summary = this.documentAuditSummaryDetails;
    return !!summary?.some(d => d?.attributeDetails?.some(a => a?.isAttributeValueMissing));
  }
  private notifyMissingAttributesIfAny(): void {
    if (this.hasMissingAttributes()) {
      this.messageService.add({
        severity: SharedConstants.Severity_Warning,
        summary: SharedConstants.AuditTrail_AttributeMissing_Message,
        life: 20000,
      });
    }
  }

}
